
import React, { useEffect } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    Table,
    Badge,
    Button,
} from "reactstrap"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

//Import Action
import {
    setBreadcrumbItems,
    getAdminTickets
} from "../../../store/actions"

const TicketsList = (props) => {
    useEffect(() => {
        const breadcrumbItems = [
            { title: "CRM", link: "#" },
            { title: "Support", link: "#" },
            { title: "Tickets", link: "#" },
        ]
        props.setBreadcrumbItems("Gestion des Tickets", breadcrumbItems)
        props.getAdminTickets()
    }, [])

    const { tickets } = props

    const getStatusBadge = (status) => {
        switch (status) {
            case 'open': return 'badge-soft-danger'
            case 'pending': return 'badge-soft-warning'
            case 'resolved': return 'badge-soft-success'
            case 'closed': return 'badge-soft-secondary'
            default: return 'badge-soft-primary'
        }
    }

    const getPriorityBadge = (priority) => {
        switch (priority) {
            case 'urgent': return 'text-danger'
            case 'high': return 'text-warning'
            case 'normal': return 'text-info'
            case 'low': return 'text-muted'
            default: return ''
        }
    }

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <div className="table-responsive">
                                <Table className="table-centered table-nowrap mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>ID</th>
                                            <th>Sujet</th>
                                            <th>Entreprise</th>
                                            <th>Priorité</th>
                                            <th>Statut</th>
                                            <th>Dernière réponse</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(tickets || []).map((ticket, key) => (
                                            <tr key={key}>
                                                <td>#{ticket.id}</td>
                                                <td>
                                                    <h6 className="font-size-14 mb-1">{ticket.subject}</h6>
                                                    <p className="text-muted mb-0">{ticket.category}</p>
                                                </td>
                                                <td>{ticket.company?.name}</td>
                                                <td>
                                                    <span className={`fw-bold ${getPriorityBadge(ticket.priority)}`}>
                                                        {ticket.priority.toUpperCase()}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className={`badge ${getStatusBadge(ticket.status)} font-size-11`}>
                                                        {ticket.status === 'open' ? 'Ouvert' :
                                                            ticket.status === 'pending' ? 'En attente' :
                                                                ticket.status === 'resolved' ? 'Résolu' : 'Fermé'}
                                                    </span>
                                                </td>
                                                <td>{new Date(ticket.updated_at).toLocaleString()}</td>
                                                <td>
                                                    <Link
                                                        to={`/admin/tickets/${ticket.id}`}
                                                        className="btn btn-primary btn-sm"
                                                    >
                                                        <i className="mdi mdi-forum-outline me-1"></i> Répondre
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        tickets: state.TicketsAdmin.tickets,
        meta: state.TicketsAdmin.meta
    }
}

export default connect(mapStateToProps, {
    setBreadcrumbItems,
    getAdminTickets
})(TicketsList)
